import React, { useState, useEffect, useRef } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Shield, Users, Clock, TrendingUp } from 'lucide-react';

const stats = [
  { icon:TrendingUp, value:97, suffix:'%', label:'Filing Approval Rate', detail:'Industry average is 55% for self-filed' },
  { icon:Users, value:5000, suffix:'+', label:'Brands Protected', detail:'From startups to established enterprises' },
  { icon:Clock, value:24, suffix:'h', label:'Response Guarantee', detail:'Dedicated case manager on every filing' },
  { icon:Shield, value:12, suffix:'yr', label:'Industry Experience', detail:'Thousands of successful registrations' },
];

const AnimatedCounter = ({ target, suffix, isVisible }) => {
  const [count, setCount] = useState(0);
  const hasAnimated = useRef(false);
  useEffect(() => {
    if(!isVisible||hasAnimated.current) return;
    hasAnimated.current=true;
    const duration=1800, steps=40, inc=target/steps;
    let cur=0;
    const timer=setInterval(()=>{cur+=inc;if(cur>=target){setCount(target);clearInterval(timer);}else setCount(Math.floor(cur));},duration/steps);
    return ()=>clearInterval(timer);
  },[isVisible,target]);
  return <span>{count.toLocaleString()}{suffix}</span>;
};

const StatsSection = () => {
  const section = useScrollAnimation({ threshold: 0.2 });
  return (
    <section data-testid="stats-section" ref={section.ref} className="py-14 md:py-20 bg-white border-b border-[#E2E2F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className={`grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-0 lg:divide-x lg:divide-[#E2E2F0] scroll-fade-up ${section.isVisible?'scroll-visible':''}`}>
          {stats.map((s,i)=>(
            <div key={i} data-testid={`stat-item-${i}`} className="lg:px-8 first:lg:pl-0 last:lg:pr-0 group cursor-default">
              <div className="w-9 h-9 border border-[#E2E2F0] bg-[#F5F3FF] flex items-center justify-center mb-3 hover-soft">
                <s.icon className="w-4 h-4 text-[#6366F1]" strokeWidth={1.5} />
              </div>
              <span className="text-3xl font-bold text-[#1E1B4B] block mb-1 tracking-tight" style={{fontFamily:"'Playfair Display',serif"}}>
                <AnimatedCounter target={s.value} suffix={s.suffix} isVisible={section.isVisible} />
              </span>
              <span className="text-sm text-[#1E1B4B] font-medium block">{s.label}</span>
              <span className="text-xs text-[#4B5563] mt-0.5 block">{s.detail}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default StatsSection;
